const SECRET_KEY = 'hidden-commons.v1.deviceSecret';
const PUBLIC_KEY = 'hidden-commons.v1.deviceKey';

export async function getDeviceKey(): Promise<string> {
  const cached = localStorage.getItem(PUBLIC_KEY);
  if (cached) return cached;
  let secret = localStorage.getItem(SECRET_KEY);
  if (!secret) {
    const bytes = new Uint8Array(32);
    crypto.getRandomValues(bytes);
    secret = [...bytes].map((byte) => byte.toString(16).padStart(2, '0')).join('');
    localStorage.setItem(SECRET_KEY, secret);
  }
  const key = await sha256Hex(`hidden-commons:${secret}`);
  const publicKey = `device_${key.slice(0, 48)}`;
  localStorage.setItem(PUBLIC_KEY, publicKey);
  return publicKey;
}

async function sha256Hex(input: string): Promise<string> {
  const bytes = new TextEncoder().encode(input);
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, '0')).join('');
}
